<div *ngIf="shouldShowError" class="caption-2 error_text" [@slideInOut]>
  <span>{{ errorMessage }}</span>
</div>
